import { EClustersType } from 'shared/map-search/types/clustersType';

import { TReduxActions } from '../../actions';
import { EResultsActionType } from '../../actions/results';

const initialState = null;

export function clustersTypeReducer(
  state: EClustersType | null = initialState,
  action: TReduxActions,
): EClustersType | null {
  switch (action.type) {
    case EResultsActionType.Succeed:
      return action.payload.clustersType || null;
    default:
      return state;
  }
}
